// import { pathRegexp } from 'path-to-regexp';
import numeral from 'numeral';

export const getRounding = (currcode) => {
  switch (currcode) {
    case 'EUR':
      return 2;
    case 'XOF':
      return 0;

    case 'USD':
      return 2;

    case 'MAD':
      return 2;

    case 'TND':
      return 3;

    default:
      return 2;
  }
};

export const getRouteAuthority = (path, routeData) => {
  let authorities;
  routeData.forEach((route) => {
    // if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
    if (route.authority) {
      authorities = route.authority;
    }

    if (route.path === path) {
      authorities = route.authority || authorities;
    }

    if (route.routes) {
      authorities = getRouteAuthority(path, route.routes) || authorities;
    }
    // }
  });
  return authorities;
};


const formatCurrency = (amount) => {

  // Check if the amount is null, undefined, or NaN
  if (amount == null || isNaN(amount)) {
    return "0 €";  // Or you can return another default value, e.g., "Invalid amount"
  }

  // Convert the amount to a float and round to two decimal places
  let formattedAmount = parseFloat(amount).toFixed(2);

  // Ensure formattedAmount is a string and check for .00
  if (formattedAmount.toString().endsWith(".00")) {
    formattedAmount = formattedAmount.slice(0, -3);
  }

  // If the parsed amount is NaN, return a default value
  if (isNaN(Number(formattedAmount))) {
    return "0 €";
  }

  // Add spaces for thousands and append the currency symbol with a space
  return formattedAmount
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €";
};


export const toCurrency = (val, currcode, hideCurrcode) => {

  return formatCurrency(val);

  let ret = `0`;

  let lcurrcode = currcode;

  if (currcode === '' || currcode == null || currcode === undefined) {
    lcurrcode = localStorage.getItem('currcode');
  }

  if (val !== 0) {
    switch (lcurrcode) {
      case 'XOF':
        ret = `${hideCurrcode ? '' : 'XOF'}  ${numeral(val).format('0,0')}`;
        break;
      case 'EUR':
        ret = `${numeral(val).format('0,0.00')} €`;
        break;
      case 'TND':
        ret = `TND  ${numeral(val).format('0,0.000')}`;
        break;
      case 'MAD':
        ret = `${hideCurrcode ? '' : 'MAD'}  ${numeral(val).format('0,0.00')}`;
        break;

      case 'USD':
        ret = `$  ${numeral(val).format('0,0.00')}`;
        break;

      default:
        ret = `${numeral(val).format('0,0.00')}`;
    }
  }
  return ret;
};

export const toEuro = (val) => `€ ${numeral(val).format('0,0.00')}`;
export const toRate = (val) => `${numeral(val).format('0,0.00000')}%`;
export const toPercentage = (val) => `${numeral(val).format('0,0.00')}%`;
export const toCoef = (val) => `${val?.toFixed(4)}`;
export const toEuroSimpleDisplay = (val) => `€ ${numeral(val).format('0a')}`;

export const toEuroSimpleDisplayK = (val) => {
  return `${numeral(val).format('0.00 a')} €`
};


export const toFormaterCurrency = (val) => {
  return new Intl.NumberFormat('en-US').format(val);
};
